import * as yup from "yup";
import { t } from "@/i18n-js/instance";

export const getEmbedValidationSchema = () => {
  const invalidURLMessage = t("courses.edit.lesson.embed_invalid_url");
  return yup.object().shape({
    url: yup.string().required(invalidURLMessage).url(invalidURLMessage),
  });
};
